import { http } from '@/utils/http/axios'

const homeApi = {
  // 分类
  getCultureCategory(params) {
    return http.request(
      {
        url: `/api/cultureCategory/select`,
        method: 'POST',
        params
      },
      {
        isTransformResponse: false
      }
    )
  },
  // 热销排行
  getRankPageparams(params) {
    return http.request(
      {
        url: `/api/CultureGoods/selectRankPage`,
        method: 'POST',
        params
      },
      {
        isTransformResponse: false
      }
    )
  },
  // 商品列表（不分页）
  getCultureGood(params) {
    return http.request(
      {
        url: `/api/CultureGoods/select`,
        method: 'POST',
        params
      },
      {
        isTransformResponse: false
      }
    )
  },
  // 商品列表（分页）
  getCultureGoods(params) {
    return http.request(
      {
        url: `/api/CultureGoods/selectPage`,
        method: 'POST',
        params
      },
      {
        isTransformResponse: false
      }
    )
  },
  // 商品详情
  getGoods(params) {
    return http.request(
      {
        url: `/api/CultureGoods/getId/${params.id}`,
        method: 'GET',
        params
      },
      {
        isTransformResponse: false
      }
    )
  },
  // 品牌
  getCultureBrand(params) {
    return http.request(
      {
        url: `/api/cultureBrand/select`,
        method: 'POST',
        params
      },
      {
        isTransformResponse: false
      }
    )
  },
  // 创建订单
  saveOrder(params) {
    return http.request(
      {
        url: `/api/cultureOrder/save`,
        method: 'POST',
        params
      },
      {
        isTransformResponse: false
      }
    )
  },
  // 订单列表
  getOrderList(params) {
    return http.request(
      {
        url: `/api/cultureOrder/selectPage`,
        method: 'POST',
        params
      },
      {
        isTransformResponse: false
      }
    )
  },
  // 订单查询
  getCultureOrder(params) {
    return http.request(
      {
        url: `/api/cultureOrder/getId/${params.id}`,
        method: 'GET',
        params
      },
      {
        isTransformResponse: false
      }
    )
  },
  // 取消订单
  cancelOrder(params) {
    return http.request(
      {
        url: `/api/cultureOrder/cancelOrder/${params.id}`,
        method: 'GET',
        params
      },
      {
        isTransformResponse: false
      }
    )
  },
  // 获取叩我token
  getToken(params, channel) {
    return http.request(
      {
        url: `/oauth/login/${params.userId}`,
        method: 'GET',
        headers: {
          AppId: channel
        },
        params
      },
      {
        isTransformResponse: false
      }
    )
  },
  // 创建订单
  verifyBuyGoods(params) {
    return http.request(
      {
        url: `${import.meta.env.VITE_VERIFYBUYGOODS_URL}/cloudjoys/goods/verifyBuyGoods`,
        method: 'POST',
        params
      },
      {
        isTransformResponse: false
      }
    )
  }
}

export default homeApi
